import { Field } from 'formik';

import { Label, LABEL_TYPE } from '@/components/generic';
import {
  ShowPasswordIcon as HidePasswordIcon,
  PasswordShownIcon as ShowPasswordIcon
} from '@/resources';

type PasswordInputProps = {
  id: string;
  label: string;
  type: string;
  isInvalid?: boolean;
  errorMessage?: string;
  showPassword: () => void;
  passwordValue: string;
  inputTestId?: string;
  toggleTestId?: string;
};

export const PasswordInput = ({
  id,
  label,
  type,
  isInvalid,
  errorMessage,
  showPassword,
  passwordValue,
  inputTestId,
  toggleTestId
}: PasswordInputProps) => (
  <div className={'space-y-2.5'}>
    <Label text={label} type={LABEL_TYPE.PARAGRAPH2} />
    <div
      className={`${
        isInvalid ? 'border-accent-red' : 'border-secondary-blue-gray'
      } relative flex items-center rounded-lg border`}>
      <Field
        data-testid={inputTestId}
        id={id}
        name={id}
        type={type}
        autoComplete='on'
        placeholder={label}
        className={'block w-full rounded-lg p-2.5 text-sm focus:outline-none'}
      />
      {type === 'password' ? (
        <HidePasswordIcon
          data-testid={toggleTestId}
          className={`absolute right-0 mr-2 translate-x-[-20%] cursor-pointer text-xl ${
            passwordValue.length > 0 ? 'fill-primary-black' : 'fill-secondary-gray'
          }`}
          onClick={showPassword}
        />
      ) : (
        <ShowPasswordIcon
          data-testid={toggleTestId}
          className={`absolute right-0 mr-2 translate-x-[-20%] cursor-pointer text-xl ${
            passwordValue.length > 0 ? 'fill-primary-black' : 'fill-secondary-gray'
          }`}
          onClick={showPassword}
        />
      )}
    </div>
    <div className='flex h-[15px] justify-end'>
      {isInvalid && errorMessage && <Label text={errorMessage} type={LABEL_TYPE.PARAGRAPH_ERROR} />}
    </div>
  </div>
);
